import { gql } from '@apollo/client'

export const GET_LIST_PRACTICE_TEST_CATEGORY = gql`
  query findAllPracticeTestCategory($params: PracticeTestCategoryQueryInput = {}) {
    findAllPracticeTestCategory(query: $params) {
      count
      items {
        id
        membershipLevel
        title
        createdAt
        updatedAt
        isLive
        subject {
          id
          tabName
        }
        order
      }
    }
  }
`

export const GET_ONE_PRACTICE_TEST_CATEGORY = gql`
  query findOnePracticeTestCategory($params: String!) {
    findOnePracticeTestCategory(id: $params) {
      id
      membershipLevel
      title
      createdAt
      updatedAt
      isLive
      subject {
        id
        tabName
        slug
        platform {
          id
          title
        }
      }
      order
    }
  }
`

export const CREATE_PRACTICE_TEST_CATEGORY = gql`
  mutation createPracticeTestCategory($params: CreatePracticeTestCategoryInput!) {
    createPracticeTestCategory(createPracticeTestCategoryInput: $params) {
      id
    }
  }
`

export const UPDATE_PRACTICE_TEST_CATEGORY = gql`
  mutation updatePracticeTestCategory($params: UpdatePracticeTestCategoryInput!) {
    updatePracticeTestCategory(updatePracticeTestCategoryInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_PRACTICE_TEST_CATEGORY = gql`
  mutation removePracticeTestCategory($params: String!) {
    removePracticeTestCategory(id: $params) {
      affected
    }
  }
`

export const GET_DASHBOARD_PRACTICE_TEST_CATEGORY = gql`
  query findDashboardPracticeTestCategory($params: PracticeTestCategoryQueryInput = {}) {
    findAllPracticeTestCategory(query: $params) {
      count
      items {
        id
        title
        membershipLevel
        subject {
          id
          slug
          tabName
        }
        isLive
        order
        practiceTests {
          id
          type
          title
          isLive
          order
          questionIds
        }
      }
    }
  }
`

export const BULK_UPDATE_PRACTICE_TEST_CATEGORY = gql`
  mutation bulkUpdatePracticeTestCategory($params: [BulkUpdatePracticeTestCategoryInput!]!) {
    bulkUpdatePracticeTestCategory(bulkUpdatePracticeTestCategoryInput: $params) {
      id
    }
  }
`
